import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// The Clipboard API needs a secure page; the textarea is for a plain-http one
const copyText = async (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.appendChild(area);
  area.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(area);
  if (!copied) throw new Error("copy failed");
};

const ICONS = {
  copy: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z",
  copied: "M5 13l4 4L19 7",
  failed: "M6 18L18 6M6 6l12 12",
};

const TITLES = {
  copy: "Хуулах",
  copied: "Хуулсан",
  failed: "Хуулж чадсангүй",
};

const COLORS = {
  copy: "text-gray-400 hover:text-purple-600 dark:hover:text-purple-400",
  copied: "text-green-600 dark:text-green-400",
  failed: "text-red-600 dark:text-red-400",
};

// Copies the value as is, so an IBAN shown in groups of four pastes without the spaces
const CopyButton = ({ value }) => {
  const [state, setState] = useState("copy");

  useEffect(() => {
    if (state === "copy") return undefined;
    const timer = setTimeout(() => setState("copy"), 2000);
    return () => clearTimeout(timer);
  }, [state]);

  const copy = async () => {
    try {
      await copyText(value);
      setState("copied");
    } catch (e) {
      setState("failed");
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      title={TITLES[state]}
      aria-label={TITLES[state]}
      className={
        "inline-flex items-center justify-center w-6 h-6 ml-1 align-middle transition-colors duration-150 rounded " +
        COLORS[state]
      }
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d={ICONS[state]}></path>
      </svg>
    </button>
  );
};

CopyButton.propTypes = {
  value: PropTypes.string.isRequired,
};

export default CopyButton;
